import React, { useState } from 'react'
import { Grid, Icon, Form } from 'semantic-ui-react'
import InputField from '../../../commonComponents/formComponents/inputField'
import DropDown from '../../../commonComponents/formComponents/dropDown'
// import MerchandiseDuty from './merchandiseDuty'
import { TranslateContext } from '../TranslateContext'
export default function TaxInformation(props) {
  let dutyIndex = 0
  let totalDuty = 1
  let isFormDisabled = false
  const { merchandiseId, lineItemIndex, isFormEnabled, invoiceIndex } = props
  const [showDutiesTaxFlag, setFlag] = useState(false)
  const translate = React.useContext(TranslateContext).translate;
  return (
    <React.Fragment>
      <Form.Group className='float-container mg-t-15' widths='equal'>
        <div
          style={{
            textTransform: 'uppercase',
            textAlign: 'center',
          }}
        >
          <span>
            <strong>{translate("DUTIES_VAT", {ns:["default", "lineItem"]})} </strong> ({!showDutiesTaxFlag ? translate("SHOW_MORE", ): translate("HIDE", {ns:["defualt", "lineItem"]})}
            <Icon
              disabled={isFormDisabled}
              aria-label={showDutiesTaxFlag ? 'Hide' : 'Show More'}
              style={{ color: '#1765ae', cursor: 'pointer' }}
              name={showDutiesTaxFlag ? 'minus circle' : 'add circle'}
              onClick={() => setFlag(!showDutiesTaxFlag)}
            />
            )
          </span>
          <span style={{ float: 'right' }}></span>
        </div>
        {showDutiesTaxFlag && (
          <Grid>
            <Grid.Row columns={'3'}>
              <Grid.Column
                className={`divFormFeild inputBox  b-rw-0 ${
                  dutyIndex === totalDuty - 1 ? 'border-bottom' : ''
                }`}
              >
                <DropDown
                  id={`taxType-${dutyIndex}`}
                  label={translate("DEPENDENCIES", {ns:["default", "lineItem"]})}
                  disabled={isFormDisabled}
                  className='field-bg dropdown100'
                  labelClass='text-none'
                  isLabel={true}
                  data={[]}
                  text={'Select'}
                  onChange={(value) => {
                    // dispatch(
                    //   updateLineItemDutyFeild(invoiceIndex,
                    //     lineItemIndex,
                    //     dutyIndex,
                    //     "taxType",
                    //     value
                    //   )
                    // );
                  }}
                  onBlur={(value) => {
                    // dispatch(
                    //   saveLineItemDutyFeild(invoiceIndex , lineItemIndex, dutyIndex, "taxType")
                    // );
                  }}
                />
                <Icon
                  //   disabled={isFormDisabled}
                  style={{
                    marginTop: '-18px',
                    position: 'relative',
                    float: 'right',
                    color: 'gray',
                  }}
                  name='cancel'
                  className='close link icon'
                  onClick={() => {
                    // dispatch(
                    //   updateLineItemDutyFeild(invoiceIndex,lineItemIndex, dutyIndex, "taxType", "")
                    // );
                    // dispatch(
                    //   saveLineItemDutyFeild(invoiceIndex ,lineItemIndex, dutyIndex, "taxType")
                    // );
                  }}
                />
              </Grid.Column>
              <Grid.Column
                className={`divFormFeild icon-gbp b-rw-0 ${
                  dutyIndex === totalDuty - 1 ? 'border-bottom' : ''
                }`}
              >
                <InputField
                  isLabel={false}
                  id={`taxAmount-${dutyIndex}`}
                  type='number'
                  label={translate("DUTIES", {ns:["default", "lineItem"]})}
                  value={''}
                  className={'field-bg'}
                  clearInput={false}
                  onChange={(value) => {
                    // dispatch(
                    //   updateLineItemDutyFeild(invoiceIndex,
                    //     lineItemIndex,
                    //     dutyIndex,
                    //     "taxAmount",
                    //     value
                    //   )
                    // );
                  }}
                  onBlur={(value) => {
                    // dispatch(
                    //   saveLineItemDutyFeild(invoiceIndex , lineItemIndex, dutyIndex, "taxAmount")
                    // );
                  }}
                  disabled={false}
                />
              </Grid.Column>
              <Grid.Column
                className={`divFormFeild icon-gbp  ${
                  dutyIndex === totalDuty - 1 ? 'border-bottom' : ''
                }`}
              >
                <InputField
                  isLabel={false}
                  id={`taxAmount-${dutyIndex}`}
                  type='number'
                  label={translate("TAXES", {ns:["default", "lineItem"]})}
                  value={''}
                  className={'field-bg'}
                  clearInput={false}
                  onChange={(value) => {
                    // dispatch(
                    //   updateLineItemDutyFeild(invoiceIndex,
                    //     lineItemIndex,
                    //     dutyIndex,
                    //     "taxAmount",
                    //     value
                    //   )
                    // );
                  }}
                  onBlur={(value) => {
                    // dispatch(
                    //   saveLineItemDutyFeild(invoiceIndex , lineItemIndex, dutyIndex, "taxAmount")
                    // );
                  }}
                  disabled={false}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        )}
      </Form.Group>
      {/* {showDutiesTaxFlag && (
        <MerchandiseDuty
          merchandiseId={merchandiseId}
          lineItemIndex={lineItemIndex}
          isFormEnabled={isFormEnabled}
          invoiceIndex={invoiceIndex}
        />
      )} */}
    </React.Fragment>
  )
}
